// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDe05PZaSgdMRvnAsf9JhWJvAlatEjJDi0",
  authDomain: "adlsc-api.firebaseapp.com",
  projectId: "adlsc-api",
  storageBucket: "adlsc-api.firebasestorage.app",
  messagingSenderId: "210635680943",
  appId: "1:210635680943:web:357763ea6fa8ac0c47f85a",
  measurementId: "G-5D014YCVRH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);

// Service d'authentification
export { app, analytics, auth };
